export default {
  common: {
    account: 'Cuenta',
    agents: 'Agentes',
    all: 'Todo',
    available: 'Disponible',
    cancel: 'Cancelar',
    cloud: 'Nube',
    copy: 'Copiar',
    current: 'actual',
    delete: 'Eliminar',
    error: 'Error',
    export: 'Exportar',
    help: 'Ayuda',
    home: 'Inicio',
    language: 'Idioma',
    links: 'Enlaces',
    loading: 'cargando',
    local: 'Local',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    metadata: 'Metadatos',
    more: 'Más',
    name: 'Nombre',
    never: 'Nunca',
    none: 'ninguno',
    notes: 'Notas',
    ok: 'Ok',
    open: 'Abrir',
    password: 'contraseña',
    project: 'proyecto',
    projects: 'Proyectos',
    publicLink: 'Enlace público',
    register: 'Registrarse',
    remove: 'Quitar',
    save: 'Guardar',
    search: 'Buscar',
    settings: 'Ajustes',
    subscribe: 'Suscribirse',
    track: 'pista',
    tracks: 'Pistas',
    unknown: 'Desconocido',
    unknownArtist: 'Artista desconocido',
    upload: 'Subir',
    username: 'usuario'
  },
  time: {
    day: 'día',
    days: 'días',
    daysAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `hace ${count} ${count === 1 ? 'día' : 'días'}`
    },
    hoursAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `hace ${count} ${count === 1 ? 'hora' : 'horas'}`
    },
    minutesAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `hace ${count} ${count === 1 ? 'minuto' : 'minutos'}`
    },
    rightNow: 'ahora mismo',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      const minuteLabel = minutes === 1 ? 'minuto' : 'minutos'
      const secondLabel = seconds === 1 ? 'segundo' : 'segundos'
      if (minutes > 0) return `${minutes} ${minuteLabel} ${seconds} ${secondLabel}`
      return `${seconds} ${secondLabel}`
    }
  },
  topBar: {
    accountFallback: 'Cuenta',
    storage: 'Almacenamiento',
    language: 'Idioma'
  },
  commandPalette: {
    placeholder: 'Buscar pistas y proyectos...',
    projects: 'Proyectos',
    tracks: 'Pistas',
    pages: 'Páginas',
    noResults: 'No se encontraron resultados',
    quickLinks: 'Enlaces rápidos',
    page: {
      home: 'Inicio',
      account: 'Cuenta',
      agents: 'Agentes',
      links: 'Enlaces',
      settings: 'Ajustes',
      help: 'Ayuda'
    }
  },
  explorer: {
    searchTitle: 'Buscar',
    trackCount: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'pista' : 'pistas'}`
    }
  },
  emptyState: {
    hello: 'hola',
    addTrack: 'Añadir una pista',
    addTrackSubtitle: 'para empezar',
    dragDrop: 'Arrastrar y soltar',
    dragDropSubtitle: 'tus archivos para subirlos rápido',
    switchStorage: 'Cambia',
    switchStorageSubtitle: 'entre nube y local en el menú superior',
    installAgent: 'Instalar agente',
    installAgentSubtitle: 'para subir tus archivos automáticamente',
    playTrack: 'Reproducir una pista',
    playTrackSubtitle: 'abre el reproductor inferior para usar efectos',
    community: '¿tienes preguntas? únete a nuestras comunidades en {discord} y {telegram}.'
  },
  create: {
    createProject: 'Crear proyecto',
    uploadTrack: 'Subir pista',
    newProject: 'Nuevo proyecto',
    artist: 'Artista',
    name: 'Nombre',
    create: 'Crear',
    loading: 'Cargando...',
    uploadCover: 'Subir portada'
  },
  upload: {
    ariaLabel: 'Subir pista',
    uploadTrack: 'Subir pista',
    analyzing: 'Analizando...',
    fileAdded: 'Archivo "{name}" añadido',
    fileReadError: 'Error al leer el archivo.',
    errorWithMessage: 'Error: {message}'
  },
  dragDrop: {
    dropToUpload: 'Suelta para subir',
    deleteDrop: 'Suelta aquí para eliminar la pista para siempre'
  },
  project: {
    upload: 'Subir',
    noTracks: 'No hay pistas',
    createdBy: 'creado por',
    trackSummary: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'pista' : 'pistas'}, ${ctx.named('duration')}`
    },
    play: 'Reproducir',
    pause: 'Pausar'
  },
  trackItem: {
    more: 'Más',
    copyPublicLink: 'Copiar enlace público',
    savedLocally: 'Guardado localmente',
    saveLocal: 'Guardar en almacenamiento local',
    saving: 'Guardando...',
    saveCloud: 'Guardar en la nube',
    deleteTrack: 'Eliminar pista',
    moveUp: 'Mover arriba',
    moveDown: 'Mover abajo',
    removeFromProject: 'Quitar de {project}',
    moveToProject: 'Mover a proyecto',
    currentProject: '(actual)',
    confirmDelete: '¿Seguro que quieres eliminar esta pista?',
    linkCopiedTitle: 'Enlace copiado',
    linkCopiedDescription: 'Enlace público copiado al portapapeles'
  },
  trackView: {
    created: 'creado {time}',
    tabs: {
      notes: 'Notas',
      metadata: 'Metadatos'
    },
    notFound: 'pista no encontrada o no disponible para ti',
    untitled: 'Sin título'
  },
  notes: {
    placeholder: 'Añade notas sobre esta pista...',
    saving: 'Guardando...',
    saveError: 'No se pudieron guardar las notas. Inténtalo de nuevo.'
  },
  metadata: {
    trackOrder: 'Orden de pista',
    artist: 'Artista',
    name: 'Nombre',
    key: 'Tonalidad',
    mode: 'Modo',
    deleteTrack: 'Eliminar pista',
    saveError: 'No se pudieron guardar los metadatos. Inténtalo de nuevo.'
  },
  lufs: {
    momentary: 'LUFS momentáneo',
    shortTerm: 'LUFS a corto plazo',
    integrated: 'LUFS integrado'
  },
  effects: {
    pitchshift: 'Cambio de tono',
    speed: 'Velocidad',
    balance: 'Balance',
    volume: 'Volumen',
    reverberation: 'Reverberación',
    distortion: 'Distorsión',
    bitcrush: 'Bitcrush',
    saveCurrentEffectsAs: 'Guardar efectos actuales como',
    presetName: 'Nombre',
    add: 'Añadir',
    availablePresets: 'Presets disponibles',
    tune: 'Afinar',
    eq: 'EQ',
    fx: 'FX',
    presets: 'Presets',
    center: 'Centro',
    left: 'Izquierda',
    right: 'Derecha'
  },
  exportPanel: {
    applyEffects: 'Aplicar efectos actuales',
    applyEffectsSubtitle: 'Exportar pista con los efectos actuales aplicados',
    exportWav: 'Exportar como WAV',
    exportMp3: 'Exportar como MP3',
    exporting: 'Exportando...',
    exportAsNewTrack: 'Exportar como pista nueva',
    creatingTrack: 'Creando pista...',
    downloadOriginal: 'Descargar original',
    originalUnavailable: 'El archivo original no está disponible.',
    downloadOriginalFailed: 'No se pudo descargar el archivo original.',
    exportAudioFailed: 'No se pudo exportar el audio de la pista.',
    waveformFailed: 'No se pudo generar la forma de onda.',
    createTrackFailed: 'No se pudo crear la pista exportada.',
    createTrackAlert: 'No se pudo crear la pista exportada: {message}',
    exportedSuffix: ' (exportación)',
    copySuffix: ' (copia)'
  },
  publicLink: {
    copy: 'Copiar',
    open: 'Abrir',
    linkCopiedTitle: 'Enlace copiado',
    linkCopiedDescription: 'Enlace público copiado al portapapeles'
  },
  settings: {
    tabs: {
      settings: 'Ajustes',
      account: 'Cuenta',
      links: 'Enlaces',
      agents: 'Agentes'
    },
    display: 'Visualización',
    language: 'Idioma',
    showBpm: 'Mostrar BPM en la vista de pista',
    showBpmSubtitle: 'Muestra los beats por minuto de cada pista en la lista',
    showLufs: 'Mostrar LUFS en la vista de pista',
    showLufsSubtitle: 'Muestra las unidades de sonoridad de cada pista en la lista',
    showKey: 'Mostrar tonalidad en la vista de pista',
    showKeySubtitle: 'Muestra tonalidad y modo de cada pista en la lista',
    playback: 'Reproducción',
    liveLoudness: 'Medición de loudness en vivo',
    liveLoudnessSubtitle: 'Muestra el medidor de loudness en vivo en el reproductor',
    persistEffects: 'Mantener efectos aplicados para todas las pistas',
    persistEffectsSubtitle: 'Mantiene los efectos aplicados aunque cambie la pista',
    keyboardShortcuts: 'Atajos de teclado',
    search: 'Buscar',
    pressShortcut: 'Pulsa la combinación deseada',
    storage: 'Almacenamiento',
    resetPresetsInfo: 'Restablecer todos los presets guardados en este navegador',
    resetPresets: 'Restablecer presets',
    resetAllWarning: '¡Atención! El botón de abajo eliminará todos los datos del almacenamiento local.',
    resetAllData: 'Restablecer almacenamiento local y eliminar todas las pistas y proyectos',
    loadingAccount: 'Cargando cuenta...',
    loadingLinks: 'Cargando enlaces...',
    loadingAgents: 'Cargando agentes...',
    authPrompt: 'Inicia sesión o regístrate para usar esta sección.',
    loginRegister: 'Iniciar sesión o registrarse',
    pageTitle: {
      settings: 'ajustes',
      account: 'ajustes de cuenta',
      links: 'enlaces públicos',
      agents: 'agentes'
    },
    presetsCleared: 'Almacenamiento de presets limpiado',
    localDataDeleted: 'Todos los datos locales eliminados',
    linkCopied: 'Enlace copiado',
    linkCopyFailed: 'No se pudo copiar el enlace'
  },
  account: {
    hello: 'Hola {name}.',
    subscriptionStatus: 'Tu suscripción está {status} ahora',
    noSubscription: 'No tienes una suscripción activa.',
    manageSubscription: 'Gestionar suscripción y métodos de pago',
    subscribeCloud: 'Suscribirse para usar la nube',
    changeUsername: 'Cambiar usuario',
    changePassword: 'Cambiar contraseña',
    saveUsername: 'Guardar usuario',
    savePassword: 'Guardar contraseña',
    newPassword: 'nueva contraseña',
    confirmPassword: 'confirmar contraseña',
    usernamePlaceholder: 'tu usuario',
    storageUsage: 'Uso de almacenamiento',
    baseStorage: 'Almacenamiento base',
    subscriptionStorage: 'Almacenamiento de suscripción',
    used: 'Usado',
    available: 'Disponible',
    deletedFilesNotice: 'Si has eliminado archivos recientemente, todavía pueden aparecer en estas métricas. Cambiará en unas horas.',
    accountId: 'id de cuenta',
    currentPeriodEnds: (ctx) => `el periodo de pago actual termina en ${ctx.named('count')} ${ctx.named('label')}`,
    accessEnds: (ctx) => `el acceso de suscripción termina en ${ctx.named('count')} ${ctx.named('label')}`,
    lastPaymentEnded: (ctx) => `el último periodo de pago terminó el ${ctx.named('date')}`,
    previousBillingDate: 'la fecha de facturación anterior',
    billingPortalError: 'Error del portal de facturación',
    billingPortalFailed: 'No se pudo abrir el portal de facturación.',
    loginRequiredUpdate: 'Debes iniciar sesión para actualizar tu perfil.',
    usernameEmpty: 'El usuario no puede estar vacío.',
    usernameUnchanged: 'El usuario no ha cambiado.',
    usernameUpdated: 'Usuario actualizado',
    usernameUpdateFailed: 'No se pudo actualizar el usuario. Inténtalo de nuevo.',
    passwordEmpty: 'La contraseña no puede estar vacía.',
    passwordsMismatch: 'Las contraseñas no coinciden.',
    passwordUpdated: 'Contraseña actualizada',
    passwordUpdateFailed: 'No se pudo actualizar la contraseña. Inténtalo de nuevo.'
  },
  links: {
    title: 'Enlaces públicos',
    description: 'Todos tus enlaces públicos aparecen aquí. Cualquiera con acceso puede escuchar el proyecto o la pista.',
    cloudOnly: 'Los enlaces públicos solo están disponibles en modo nube. Cambia a almacenamiento en la nube para crearlos y gestionarlos.',
    noLinks: 'No hay enlaces públicos disponibles',
    createFirst: 'Crea tu primer enlace público para empezar a compartir.',
    confirmDelete: '¿Seguro que quieres eliminar este enlace?',
    notFoundTitle: 'Enlace no encontrado o caducado',
    notFoundDescription: 'El enlace al que intentas acceder no es válido o ha caducado.',
    unknownUser: 'desconocido'
  },
  agents: {
    authorizeTitle: 'Autorizar agente',
    authorizeDescription: 'Permite que este agente se conecte a tu cuenta.',
    loginToAuthorize: 'Inicia sesión para autorizar este agente.',
    wantsConnect: 'Este agente quiere conectarse a tu cuenta para subir archivos de audio automáticamente.',
    permissionUpload: 'Subir pistas',
    permissionMetadata: 'Crear metadatos de pistas',
    authorize: 'Autorizar',
    cancel: 'Cancelar',
    authorizedTitle: 'Agente autorizado',
    authorizedDescription: 'Ya puedes cerrar esta ventana y volver a la aplicación del agente.',
    desktopTitle: 'Agente de escritorio',
    installDescription: 'Instala el agente de demoparty en tu PC o Mac para subir automáticamente tus renders recientes.',
    warningLabel: 'ADVERTENCIA: ',
    alphaWarning: 'el agente está en estado alpha y puede ser inestable.',
    downloadMacApple: 'Descargar para Mac con Apple Silicon',
    downloadMacIntel: 'Descargar para Mac con Intel',
    downloadWindows: 'Descargar para Windows x64',
    signingNotice: 'Estas builds no están firmadas digitalmente porque el proyecto sigue en desarrollo. Es normal ver avisos de seguridad al abrirlas. Las builds firmadas llegarán más adelante.',
    activeTitle: 'Agentes activos',
    connectedDescription: 'Agentes conectados a tu cuenta.',
    loginToManage: 'Inicia sesión para gestionar tus agentes.',
    noAgents: 'Aún no hay agentes conectados.',
    lastUsed: 'Último uso',
    revoke: 'Revocar',
    remove: 'Quitar',
    confirmRemove: '¿Seguro que quieres quitar este agente?',
    authorizeFailed: 'No se pudo autorizar el agente. Inténtalo de nuevo.'
  },
  login: {
    intro: 'Debes iniciar sesión si quieres usar funciones de nube y beneficios de suscripción. Si no, puedes usar el servicio localmente gratis.',
    subscriptionBenefits: 'beneficios de suscripción',
    login: 'Iniciar sesión',
    register: 'Registrarse',
    forgot: 'Olvidé mi contraseña',
    email: 'e-mail',
    password: 'contraseña',
    repeatPassword: 'repetir contraseña',
    or: 'o',
    google: 'Iniciar sesión con Google',
    apple: 'Iniciar sesión con Apple',
    resetPassword: 'Restablecer contraseña',
    resetDescription: 'Te enviaremos un enlace de acceso para que puedas establecer una contraseña nueva.',
    sendResetLink: 'Enviar enlace de restablecimiento',
    invalidToken: 'Token inválido o caducado',
    enterEmail: 'Introduce tu e-mail',
    resetSent: 'Si la cuenta existe, enviamos un enlace de acceso a tu e-mail.',
    resetFailed: 'No se pudo enviar el enlace. Inténtalo de nuevo.'
  },
  googleCallback: {
    wait: 'Espera, estamos iniciando sesión...'
  },
  subscribe: {
    cloudRequiredTitle: 'Se requiere almacenamiento en la nube',
    cloudRequiredMessage: 'Esta función solo está disponible con almacenamiento en la nube y una suscripción activa.',
    title: 'Empieza local. Mejora para auto-subida.',
    description: 'La nube te da una biblioteca sincronizada en todos tus dispositivos.',
    localFree: 'Puedes usar la app gratis en modo local.',
    cloudIncludes: 'La nube incluye',
    featureLibrary: 'Una biblioteca sincronizada entre web y iPhone',
    featureAgent: 'Auto-subida con agente de escritorio para renders recientes',
    featureStorage: '100 GB de almacenamiento en la nube para pistas',
    featureLinks: 'Enlaces públicos persistentes para pistas y proyectos',
    featureTools: 'Todas las herramientas locales de análisis, efectos y exportación incluidas',
    monthly: 'Mensual',
    monthlyDescription: 'Sincronización en la nube, cancela cuando quieras',
    yearly: 'Anual',
    yearlyDescription: 'Mejor valor para sincronización en la nube',
    saveTen: 'Ahorra 10%',
    perMonth: '/mes',
    billedMonthly: 'Facturado mensualmente',
    billedYearly: '$53.89 facturados anualmente',
    openingCheckout: 'Abriendo checkout...',
    subscribePlan: 'Suscribirse {plan}',
    registerSubscribe: 'Registrarse y suscribirse',
    securePayment: 'Pago seguro vía Polar. Cancela cuando quieras desde los ajustes de tu cuenta.',
    customPlan: '¿Necesitas un plan personalizado o tienes preguntas? Contáctanos en',
    privacy: 'Política de privacidad',
    terms: 'Términos de servicio',
    refund: 'Política de reembolso',
    checkoutFailed: 'No se pudo crear el checkout. Inténtalo de nuevo.'
  },
  thanks: {
    title: '¡Gracias por tu suscripción!',
    description: 'Ahora puedes usar almacenamiento en la nube. Para gestionar tu suscripción, revisa la página de tu cuenta.',
    startWorking: 'Empezar a trabajar',
    communities: 'Únete a nuestras comunidades',
    support: 'Si tienes problemas, contáctanos en {email} o usando los enlaces de comunidad de arriba.'
  },
  help: {
    title: 'Ayuda',
    intro: 'demoparty es un espacio de trabajo para música inacabada y proyectos en progreso. Te permite guardar demos, aplicar efectos, editar tags y seguir metadatos técnicos. El uso local es completamente gratis.',
    uploadTitle: 'Subida',
    uploadText: 'Puedes añadir una pista haciendo clic en el botón Add de la página principal. Durante la subida, el sistema detecta automáticamente tonalidad, BPM y LUFS. Cuando termine, recibirás una notificación de confirmación.',
    storageTitle: 'Almacenamiento',
    storageText: 'demoparty ofrece dos opciones de almacenamiento: local y nube.',
    localStorageText: 'El almacenamiento local guarda todos los datos solo en tu dispositivo. Las pistas y proyectos solo están disponibles en el navegador donde se subieron. Se usa IndexedDB. No hace falta registro y no se envía ningún dato.',
    cloudStorageText: 'El almacenamiento en la nube guarda tus datos en servidores de demoparty. Puedes acceder a tus pistas desde cualquier lugar en cualquier momento. Requiere registro y una suscripción activa.',
    agentsTitle: 'Agentes',
    agentsText: 'Al usar almacenamiento en la nube, puedes instalar un agente de escritorio. El agente sube automáticamente los renders nuevos a la nube.',
    publicLinksTitle: 'Enlaces públicos',
    publicLinksText: 'Los usuarios de la nube pueden crear enlaces públicos a pistas y proyectos. En la página del proyecto, haz clic en el botón de enlace. Para pistas, usa el mismo icono en el menú desplegable de la pista. Todos los enlaces generados se gestionan desde Ajustes.',
    exportTitle: 'Exportar',
    exportText: 'Las pistas se pueden exportar con todos los efectos aplicados. Abre la página de la pista y selecciona Exportar. Puedes descargar el archivo original o exportarlo como MP3 o WAV.',
    supportTitle: 'Soporte',
    supportText: "Para problemas relacionados con suscripciones de demoparty cloud, contáctanos en support{'@'}demoparty.app.",
    attributionsTitle: 'Atribuciones',
    attributionsText: 'Las siguientes bibliotecas hicieron posible este proyecto. El crédito pertenece a sus respectivos desarrolladores.'
  },
  cover: {
    upload: 'Subir portada',
    change: 'Cambiar portada',
    delete: 'Eliminar portada',
    loading: 'Cargando...',
    selectImage: 'Selecciona un archivo de imagen',
    uploadError: 'Error al subir la portada'
  }
}
